/* eslint-disable no-unused-vars */
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { VehicleScheduleState } from '../../../redux/type';
import { enumTranslator } from '../../../utils';
import { CLSTAG, PncTaskType } from '../../../utils/constant';
import { clstagStr } from '../../../utils/util';
import { TakeOverStatus } from '@/views/PatrolMode/types';
interface Props {
  isStoped: boolean;
  operatorIsSelf: boolean;
  disabled: boolean;
  mileageToNextStop: number;
  takeOverStatus: string;
  onShowMessage: (name: string) => void;
}
const AsArrived = (props: Props) => {
  const singleVehiclePageInfo = useSelector(
    (state: RootState) => state.singleVehiclePageInfo,
  );
  const { pncTaskType } = singleVehiclePageInfo;
  const { isStoped, operatorIsSelf, disabled, takeOverStatus } = props;
  let cls = '';
  const usable =
    isStoped &&
    operatorIsSelf &&
    !disabled &&
    pncTaskType === PncTaskType.ACTIVE &&
    takeOverStatus === TakeOverStatus.TAKEOVER;
  if (usable) {
    cls = 'item asArrived';
  } else {
    cls = 'item asArrived disabled';
  }

  const handleClick = (e: any) => {
    try {
      if (e.currentTarget.className.includes('disabled')) {
        return;
      }
      props.onShowMessage('arrived');
      // eslint-disable-next-line no-empty
    } catch (e) {}
  };

  return (
    <li
      className={cls}
      onClick={handleClick}
      clstag={clstagStr(CLSTAG.AsArrivedBtn)}
    >
      {usable ? <div className='img_normal' /> : <div className='img_gray' />}

      <h3 className='operate_key'>视同到达</h3>
    </li>
  );
};
export default AsArrived;
